import { render, staticRenderFns } from "./tag-list.vue?vue&type=template&id=0db8017e&scoped=true&"
import script from "./tag-list.vue?vue&type=script&lang=js&"
export * from "./tag-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8017e",
  null
  
)

export default component.exports